export default [
  {
    fullName: 'Игорь Плотников',
    jobTitle: 'Руководитель направления развития сервисов информационной безопасности T1 Облако',
    description: '',
    photo: require('@/assets/speakers/419.jpg')
  }
]
